import { defineNuxtPlugin } from '#app'
import { createGtm, type VueGtmUseOptions } from '@gtm-support/vue-gtm'

export default defineNuxtPlugin({
  name: 'gtm-tracking',
  async setup({ $config, vueApp }) {
    const { gtm } = $config.public
    const IS_DEV = process.env.NODE_ENV === 'development'

    const gtmTagId = gtm.id
    const options = {
      id: gtmTagId,
      nonce: '2726c7f26c',
      defer: false,
      compatibility: false,
      enabled: true,
      debug: IS_DEV,
      enableRouterSync: true,
      devtools: true,
      trackOnNextTick: false,
    }

    if (gtmTagId) {
      const router = useRouter()

      const pluginOptions: VueGtmUseOptions = {
        ...options,
        vueRouter:
          options.enableRouterSync && router
            ? (router as VueGtmUseOptions['vueRouter'])
            : undefined,
      }

      vueApp.use(createGtm(pluginOptions))
    }
  },
})
